<h1 mat-dialog-title>{{'about.appInfo' | localize }}</h1>
<div mat-dialog-content class="app-info">
    <div class="row">
        <div class="col-md-6 col-sm-6">
          <div class="row app-info-row">
            <div class="app-info-label col-md-6 col-sm-6">{{'about.appName' | localize }}</div>
            <span class="seperator">:</span>
            <div class="app-info-value col-md-6 col-sm-6">Rem2Cloud</div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="row app-info-row">
            <div class="app-info-label col-md-6 col-sm-6">{{'about.appVersion' | localize }}</div>
            <span class="seperator">:</span>
            <div class="app-info-value col-md-6 col-sm-6">NAA31904BAB-V01</div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="row app-info-row">
            <div class="app-info-label col-md-6 col-sm-6">{{'about.version' | localize }}</div>
            <span class="seperator">:</span>
            <div class="app-info-value col-md-6 col-sm-6">2.2</div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="row app-info-row">
            <div class="app-info-label col-md-6 col-sm-6">{{'about.buildDate' | localize }}</div>
            <span class="seperator">:</span>
            <div class="app-info-value col-md-6 col-sm-6">04/02/2026</div>
          </div>
        </div>
        <!-- <div class="col-md-6 col-sm-6">
          <div class="row app-info-row">
            <div class="app-info-label col-md-6 col-sm-6">{{'about.databaseName' | localize }}</div>
            <span class="seperator">:</span>
            <div class="app-info-value col-md-6 col-sm-6">r2cdb</div>
          </div>
        </div> -->
    </div>   
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button class="reset_bg" (click)="onDialogCancel()">{{'about.close' | localize }}</button>
</div>
